/**
 * Global Drawer Stack - Public API
 * 
 * Exports all public APIs for the global drawer stack system.
 * Maintains backward compatibility with the original global-drawer-stack.tsx
 */

// Context and Provider
export { GlobalDrawerStackContext, useGlobalDrawerStack } from "./context";
export { GlobalDrawerStackProvider } from "./provider";

// Components
export { CentralizedDrawer } from "./components/CentralizedDrawer";
export { DrawerHeader } from "./components/DrawerHeader";
export { DrawerContent } from "./components/DrawerContent";

// Hooks
export { useDrawerState } from "./hooks/useDrawerState";
export { useDrawerConfig } from "./hooks/useDrawerConfig";
export { useTouchGestures } from "./hooks/useTouchGestures";
export {
  useMessageDetailDrawer,
  createSpecializedDrawerHook,
} from "./hooks/useSpecializedDrawers";

// Types
export type {
  DrawerConfig,
  GlobalDrawerId,
  GlobalDrawerStackContextType,
} from "./types";
export { GLOBAL_DRAWER_IDS, DEFAULT_DRAWER_CONFIG } from "./types";

// Utilities
export {
  mergeDrawerConfig,
  getDefaultDrawerConfig,
} from "./utils/drawerConfig";
export {
  calculateVelocity,
  shouldCloseOnSwipe,
  calculateSwipeOffset,
  type TouchData,
} from "./utils/touchGestures";
export {
  mapSideToPosition,
  mapHeightToSize,
  getViewportConstrainedStyles,
} from "./utils/drawerPosition";
